/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performResolutionObj: {},
  resolutionDetailObj: {},
  planType: [],
  rebateProgram: [],
  errorMsgPreInvoice: [],
  rebateProgramName: {},
  begin: '',
  end: '',
  quarterFrom: '',
  selectedOption: 'Adjustment_Date_Range',
  selectedReportOption: 'Detail',
  preInvoiceSum: [],
  preInvoiceDet: [],
  displayObj: {
    rebateProgramName: {},
    begin: '',
    end: '',
    quarterFrom: '',
    selectedReportOption: 'Detail',
    selectedOption: 'Adjustment_Date_Range',
    preInvoiceSum: [],
    preInvoiceDet: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_INVOICE:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_INVOICE:
      return { ...state, resolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_INVOICE:
      return { ...state, errorMsgPreInvoice: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_INVOICE:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_INVOICE:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_INVOICE:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_QUARTER_INVOICE:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.SELECT_OPTION:
      return { ...state, selectedOption: action.payload };
    case actionTypes.SELECT_REPORT_OPTION:
      return { ...state, selectedReportOption: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_INVOICE:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_PRE_INVOICE_SUMMARY:
      let displayObj = {
        ...state.displayObj,
        preInvoiceSum: action.payload,
      };
      return {
        ...state,
        preInvoiceSum: action.payload,
        displayObj,
      };
    case actionTypes.GET_PRE_INVOICE_DETAIL:
      let displayObj1 = {
        ...state.displayObj,
        preInvoiceDet: action.payload,
      };
      return {
        ...state,
        preInvoiceDet: action.payload,
        displayObj: displayObj1,
      };

    case actionTypes.SET_DATE_RANGE_INVOICE:
      return { ...state, ...action.payload };
    //refresh
    case actionTypes.REFRESH_PREINVOICE_UNIT_ADJUSTMENT:
      return {
        ...state,
        performResolutionObj: {},
        resolutionDetailObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgPreInvoice: [],
        rebateProgramName: {},
        begin: '',
        end: '',
        quarterFrom: '',
        selectedOption: 'Adjustment_Date_Range',
        selectedReportOption: 'Detail',
        preInvoiceSum: [],
        preInvoiceDet: [],
      };
    case actionTypes.REFRESH_PREINVOICE_UNIT_ADJUSTMENT_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
